import React from "react";
import PropTypes from "prop-types";
import { Paper } from "@mui/material";

/** Compact filter shell for vendor catalog/search bars. */
export default function VendorFilterPaper({ children, sx = {}, ...otherProps }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 1.5, md: 2 },
        borderRadius: "14px",
        border: "1px solid rgba(0, 0, 0, 0.06)",
        backgroundColor: "#ffffff",
        boxShadow: "0 1px 3px rgba(15, 23, 42, 0.06)",
        width: "100%",
        boxSizing: "border-box",
        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </Paper>
  );
}

VendorFilterPaper.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};
